import React, { useState, useEffect, useRef } from "react"
import { useAppDispatch, useAppSelector } from "hooks"
import { AntdButton, GlobalSidebar } from "components"
import BranchForm from "./BranchForm"
import { filteredListBySearch, getBranches, selectBranchById, selectBranchIsLoading } from "store/Branches/branch.slice"
import { getPayGroup } from "store/PayGroups/payGroup.slice"
import BranchSideBar from "./BranchSideBar"
import { getSDCounties } from "store/StaticData/SDCounties.slice"
import AuditTrail from "components/AuditTrail"
import { Entities } from "types/auditTrail.types"
import { getSDQualifications } from "store/StaticData/SDQualifications.slice"
import { useAdminQueryParams } from "hooks"
import { sortByProperty } from "config/utils"

let searchString1 = ""
let timeoutId: NodeJS.Timeout

const Index: React.FC = () => {
	const dispatch = useAppDispatch()

	const [branchSelection, setBranchSelection] = useState<string>("")
	const [searchString, setSearchString] = useState("")
	const [searchOnFields] = useState(["name"])

	const branchesLoading = useAppSelector(selectBranchIsLoading())
	const { params, setSearchParams } = useAdminQueryParams()
	const { selected: selectedBranch } = params
	const branch = useAppSelector(selectBranchById(selectedBranch || ""))
	const filteredList = useAppSelector(filteredListBySearch(searchString, searchOnFields))
	// const newBranch = useAppSelector(selectNewBranchAdded())
	const isNewBeingCreated = useRef(false)

	useEffect(() => {
		dispatch(getBranches(true))
		dispatch(getSDQualifications())
	}, [])

	useEffect(() => {
		if (!selectedBranch && !!filteredList.length && !isNewBeingCreated.current) {
			setSearchParams({ selected: filteredList[0]._id })
		}
	}, [params, filteredList])

	// useEffect(() => {
	// 	if (newBranch?._id) {
	// 		setSearchParams({ ...params, selected: newBranch._id })
	// 		newBranch && dispatch(ClearBranch())
	// 	}
	// }, [params, newBranch])

	useEffect(() => {
		dispatch(getPayGroup())
		dispatch(getSDCounties())
	}, [])

	const handleSelected = (branchId: string) => {
		setSearchParams({ selected: branchId })
		isNewBeingCreated.current = false
	}

	const handleAddBranch = (e: React.MouseEvent) => {
		e.preventDefault()
		isNewBeingCreated.current = true
		setSearchParams({ selected: "" })
	}
	const createTimeout = (time: number) => {
		return setTimeout(() => {
			setBranchSelection("")
			searchString1 = ""
		}, time)
	}

	const onKeyUpHandler = (e: any) => {
		if (timeoutId) clearTimeout(timeoutId)
		searchString1 += e.key
		setBranchSelection(prev => {
			let prev1 = prev
			prev1 += e.key

			return prev1
		})
		const filteredBranches = filteredList?.filter(({ name }: any) =>
			`${name}`.toLowerCase().includes(searchString1.toLowerCase()),
		)
		if (filteredBranches?.length) {
			setSearchParams({ selected: filteredBranches[0]._id })
		}
		timeoutId = createTimeout(500)
	}

	return (
		<div>
			<GlobalSidebar>
				<BranchSideBar
					setSearchString={setSearchString}
					searchText={branchSelection}
					branches={filteredList.sort(sortByProperty("name"))}
					selected={selectedBranch || ""}
					loading={branchesLoading}
					handleSelected={handleSelected}
					onKeyUpCapture={onKeyUpHandler}
				/>
			</GlobalSidebar>

			<div className="flex flex-col">
				<div className="flex justify-between">
					<AuditTrail id={branch?._id} name={Entities.BRANCHES} />
					<AntdButton className="ml-auto" onClick={handleAddBranch}>
						Add branch
					</AntdButton>
				</div>
				<BranchForm branch={branch} />
			</div>
		</div>
	)
}

export default Index
